import * as types from './types'
import storage from '@/plugins/storage'
export default {
  token: storage.session.getItem(types.SESSION_TOKEN_NAME),
  profile: storage.session.getItem(types.SESSION_PROFILE) ? JSON.parse(storage.session.getItem(types.SESSION_PROFILE)) : null,
  searchTerm: '',
  components: null,
  vin: null,
  vehicle: null
}



// WEBPACK FOOTER //
// ./src/store/modules/alldata/state.js